import styled from 'styled-components';
import InterviewRecordingUploader from '../InterviewRecordingUploader';

export const Title = styled.h1`
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  color: ${(props) => props.theme.colors['neutral-80']};
  margin-bottom: 24px;
`;

export const RecordingUploader = styled(InterviewRecordingUploader)`
  margin-bottom: 24px;
`;
